export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10184.737b3651.jpg";